import React from 'react'
import NavbarComponent from '../components/navbar'
import LabelsDiv from '../components/labelsDiv'
import './styles/labelspage.css'
import Footer from '../components/footer'

const LabelsPage = () => {
    return (
        <>
            <NavbarComponent />
            <main className="ocn-wrap">
                <div className="ocn-pagehead">
                    <p className="ocn-eyebrow">Label</p>
                    <h1>Label a commit</h1>
                    <p>Get a random commit, read the change on GitHub, then rate it on one or more attributes.</p>
                </div>
                <LabelsDiv />
            </main>
            <Footer />
        </>
    )
}

export default LabelsPage
